// const appurlll = 'https://accuracy-predictions-hurricane-animal.trycloudflare.com';
// async function shippingZone(){
//   const shippingZoneReq = await fetch(`${appurlll}/api/countries`, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({"shopUrl": Shopify.shop}),
//   });
//   const shippingZoneRes = await shippingZoneReq.json();
//   const domesticShippingZone = shippingZoneRes.data.shipping_zones.filter(item => item.name == 'Domestic')[0]?.countries;
//   console.log('domesticShippingZone ',domesticShippingZone);
// }
// shippingZone();



const getCustomerDetails = async (customerId) => {
    const getCustomerReq = await fetch(`${APP_URL}/api/customer`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({"shopUrl": Shopify.shop,"type":"get", "customerId": customerId}),
    });
    const createCustomerRes = await getCustomerReq.json();

    const endpointNote = `${APP_URL}/api/customer/metafield`;
    const getCustomerNoteReq = await fetch(endpointNote, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({"shop": Shopify.shop,"type":"get", "customerId": customerId}),
    });
    const getCustomerNoteRes = await getCustomerNoteReq.json();
    const noteMetafield = getCustomerNoteRes.data.metafields.find((item) => item.namespace === 'custom' && item.key === 'note');
  
    const customer_notes = noteMetafield ? noteMetafield.value.split(", ") : createCustomerRes.data.customer.note.split(", ");
    
    const formatted_notes = customer_notes.map(item => {
        const [name, value] = item.split(": ", 2);
        return {
            "name": name.replace(/'/g, ""),
            "value": value
        };
    });
    
    const accountNumber = formatted_notes.filter(item => item.name == 'Account Number');
    if(accountNumber.length > 0){document.querySelector('.bill-throght-reseller input#account-number').value = accountNumber[0].value;}

    const membershipNumber = formatted_notes.filter(item => item.name == 'Membership Number');
    if(membershipNumber.length > 0){document.querySelector('.pay-with-capricorn input#account-number').value = membershipNumber[0].value;}

    const paymentMethod = formatted_notes.filter(item => item.name == 'Payment Method');
    if(paymentMethod.length > 0){document.querySelector(`.stp-payment-box input[value="${paymentMethod[0].value}"]`)?.click();}

    const reselletLocation = formatted_notes.filter(item => item.name == 'Selected Reseller Location');
    if(reselletLocation.length > 0){
      const prefredRL = reselletLocation[0].value.split(',');
      const sloc = prefredRL.reduce((acc, item) => {
          const [key, value] = item.split(':');
          acc[key.trim()] = value.trim(); // Add key-value pair to the accumulator object
          return acc;
      }, {});
      console.log('sloc sloc ',sloc);
      document.querySelector('.selected-reseller-lication').innerHTML = `<span class="name">${sloc.Title}</span> - <span class="suburb">${sloc.Suburb}</div>`;
      document.querySelector('.selected-reseller-lication').classList.add('active');
      document.querySelector('.selected-reseller-lication').setAttribute('data-location',`Title:${sloc.Title},Address:${sloc.Address},Suburb:${sloc.Suburb},State:${sloc.State},Country:${sloc.Country},Postcode:${sloc.Postcode},Phone:${sloc.Phone}`);

      const slacHTML = `<div class="ssr-list-wrap">
            <div class="ssr-location">
              <div class="ssr-location-title">Preferred Reseller Location</div>
              <div class="ssr-location-name">${sloc.Title}</div>
              <div class="ssr-location-address">${sloc.Address}<br>${sloc.Suburb +' '+ sloc.State}<br/>PH: ${sloc.Phone}</div>
            </div>
         </div>`;

      document.querySelector('.btr-preselected-reseller-location').innerHTML = slacHTML;
      
    }
  
    return createCustomerRes.data.customer;
}
getCustomerDetails(customer.id);

const pbbButton = document.querySelector('.product-booking-btn button.procced');
if(pbbButton){
 pbbButton.addEventListener('click', function(){
  let validationCompleate = true;

  const dontVin = document.querySelectorAll('.vin-or-rego-wrapper label.form-item.dont-vip input:checked');
  const vinRegoText = document.querySelector('.vin-or-rego-wrapper input[type=text]');
  if(dontVin.length == 0 && vinRegoText?.value == ''){
    vinRegoText.classList.add('error');
    validationCompleate = false;
  }
  
  let itemImageSelected = false;
  const itemImageLength = document.querySelectorAll('.select-item-onclick .stp-block-img').length;
  const itemImageActivelength = document.querySelectorAll('.select-item-onclick .stp-block-img.active').length;
   
  if(!validationCompleate){
   document.querySelector('.error-message-wrap').innerHTML = 'Please fill all the required fields above.';
  }
  else if(itemImageActivelength != itemImageLength){
    // document.querySelector('.sio-error-message').innerHTML = 'You have not selected all the required items image, please click on the images below to confirm the items.';
    // const targetElement = document.querySelector('.sio-items-wrap');
    // if (targetElement) {targetElement.scrollIntoView({ behavior: 'smooth' });}
    document.querySelector('.common-popup-container')?.classList.add('show');
  }
  else{
    document.querySelector('.product-booking-btn button.procced').classList.add('loading');
    setTimeout(function(){
      document.querySelector('.product-booking-btn button.procced').classList.remove('loading');
      document.querySelector('.steps-main-wrapper').classList.remove('step-first-active');
      document.querySelector('.steps-main-wrapper').classList.add('step-second-active');
      window.scrollTo({top: 0,behavior: 'smooth'});
    },1000);
  }
}); 
}

document.querySelectorAll('.steptriggers button.back,.common-popup-inner-container button.mfp-close').forEach(item => {
   item.addEventListener('click', function(){
      document.querySelector('.common-popup-container')?.classList.remove('show'); 
   });
});
document.querySelectorAll('.steptriggers button.continue').forEach(item => {
   item.addEventListener('click', function(){
      document.querySelector('.common-popup-container')?.classList.remove('show');
      // document.querySelectorAll('.select-item-onclick .stp-block-img').forEach(item => {item.classList.add('active');});
      document.querySelector('.steps-main-wrapper').classList.remove('step-first-active');
      document.querySelector('.steps-main-wrapper').classList.add('step-second-active');
      window.scrollTo({top: 0,behavior: 'smooth'});
   });
});


/* back to product details page from product booking page */
document.querySelectorAll('.product-booking-btn button.button.back').forEach(item => {
   item.addEventListener('click', function(){
      const backurl = this.dataset.burl;
      window.location.href = backurl;
   }); 
});

function errorMessage(){
  document.querySelector('.faults-checkbox-wrap')?.classList.remove('error');
  document.querySelector('textarea[name="fault-description"]')?.classList.remove('error');
  document.querySelector('.vin-or-rego-wrapper input[type=text]')?.classList.remove('error');
  document.querySelector('.normal-partnumber-wrap input')?.classList?.remove('error');
  document.querySelectorAll('.lets-get-started .form-item-input input').forEach(input => {input.classList.remove('error');});
  document.querySelectorAll('.wnmb-items .form-item.half-width textarea').forEach(textarea => {textarea.classList.remove('error');});
  document.querySelectorAll('.customer-shipping-address input,.customer-shipping-address select').forEach(item => {
     item.classList.remove('error');
  });
  document.querySelector('.error-message-wrap').innerHTML = '';
}


document.querySelectorAll('.stp-form-main input[type="checkbox"], .stp-form-main select').forEach(item => {
   item.addEventListener('change', function(){
       errorMessage();
   });
});
document.querySelectorAll('.stp-form-main input[type="text"],.stp-form-main textarea').forEach(item => {
   item.addEventListener('keyup', function(){
       errorMessage();
   });
});

const additionalPartChecked = document.querySelector('.additional-part-checkbox');
if(additionalPartChecked){
 additionalPartChecked.addEventListener('click', function(){
  console.log('this.checked ',this.checked);
  if(this.checked){
    document.querySelector('.additional-part-input-wrap').style.display = 'block';
  }else{
    document.querySelector('.additional-part-input-wrap').style.display = 'none';
    document.querySelector('.additional-part-input-wrap input').value = '';
  }
}); 
}

const dontVip = document.querySelector('.vin-or-rego-wrapper label.form-item.dont-vip input');
if(dontVip){
    dontVip.addEventListener('click', function(){
       if(this.checked){
           document.querySelector('.vin-or-rego-wrapper .warning-message').style.display = 'block';
       }else{
           document.querySelector('.vin-or-rego-wrapper .warning-message').style.display = 'none';
       }
      errorMessage();
    });
}

document.querySelectorAll('.stp-payment-box .form-items label.form-item input').forEach(item => {
   item.addEventListener('change', function(){
       document.querySelector('.stp-payment-box .form-items label.form-item.active').classList.remove('active');
       this.closest('label.form-item').classList.add('active');
       const correctPaymentmethod = this.value;
       if(correctPaymentmethod == 'Bill through Reseller'){
         document.querySelector('.bill-throght-reseller').classList.add('show');
       }else{
         document.querySelector('.bill-throght-reseller').classList.remove('show');
       }
     
       if(correctPaymentmethod == 'Pay with Capricorn'){
         document.querySelector('.pay-with-capricorn')?.classList.add('show');
       }else{
         document.querySelector('.pay-with-capricorn')?.classList.remove('show');
       }

       const spbError = document.querySelector('.stp-psm-btr-error');
      if (spbError) {spbError.style.display = 'none';}
   }) 
});


document.querySelector('.rsb-search-box input').addEventListener('keyup', function(){
   const searchquery = this.value.toLowerCase();
   // console.log('searchquery ',searchquery);
  document.querySelector('.reseller-list-popup').classList.remove('error');
   if(searchquery.length > 3){
     const filejson = window.excel.fileJson;
     const searchArray = filejson.filter(item => item.Title.toLowerCase().includes(searchquery) || item.Postcode == searchquery || item.Address.toLowerCase().includes(searchquery) || item.Phone == searchquery || item.Country.toLowerCase().includes(searchquery) || item.State.toLowerCase().includes(searchquery));
     // console.log('searchArray ',searchArray);
     let locationListHTMl = '';
     searchArray.forEach((result,index) => {
         const locationHtml = `<div class="ssr-list-wrap">
            <div class="ssr-location">
              <div class="ssr-location-name">${result.Title}</div>
              <div class="ssr-location-address">${result.Address}<br>${result.Suburb +' '+ result.State}<br/>PH: ${result.Phone}</div>
            </div>
            <div class="ssr-set-btn" onClick="setNearestReseller(this,'${searchquery}',${index});"><button type="button">Set Nearset Reseller</button></div>
         </div>`;
         locationListHTMl += locationHtml;
     });
     const resultHtml = locationListHTMl == '' ? `<div class="ssr-location-wrapper"><div class="not-fount">Location not found.</div></div>`:`<div class="ssr-location-wrapper"><div class="ssr-title">These are your ${searchArray.length} closest resellers
</div><div class="ssr-location-grid">${locationListHTMl}</div></div>`;

     document.querySelector('.reseller-search-result').innerHTML = resultHtml;
   }
});

document.querySelector('.btr-account-info input#account-number').addEventListener('keyup', function(){
  document.querySelector('.btr-account-info').classList.remove('error');
});

function setNearestReseller(selm, searchquery, index){
  document.querySelector('.ssr-location-grid .ssr-list-wrap.active')?.classList.remove('active');
  selm.closest('.ssr-list-wrap').classList.add('active');
  
  const filejson = window.excel.fileJson;
  const searchArray = filejson.filter(item => item.Title.toLowerCase().includes(searchquery) || item.Postcode == searchquery || item.Address.toLowerCase().includes(searchquery) || item.Phone == searchquery || item.Country.toLowerCase().includes(searchquery) || item.State.toLowerCase().includes(searchquery));
  console.log('location ', searchArray[index]);
  const sloc = searchArray[index];
  document.querySelector('.selected-reseller-lication').innerHTML = `<span class="name">${sloc.Title}</span> - <span class="suburb">${sloc.Suburb}</div>`;
  document.querySelector('.selected-reseller-lication').classList.add('active');
  document.querySelector('.selected-reseller-lication').setAttribute('data-location',`Title:${sloc.Title},Address:${sloc.Address},Suburb:${sloc.Suburb},State:${sloc.State},Country:${sloc.Country},Postcode:${sloc.Postcode},Phone:${sloc.Phone}`);
}

document.querySelector('span.selected-reseller-lication').addEventListener('click', function(){
     document.querySelector('.reseller-list-popup').scrollIntoView({ behavior: 'smooth' });
});

document.querySelector('.authorise-checkbox input').addEventListener('change', function(){
    document.querySelector('.authorise-checkbox').classList.remove('error');
});

document.querySelector('.accept-term-condition input')?.addEventListener('change', function(){
    document.querySelector('.accept-term-condition').classList.remove('error');
});

/* create order js */

document.querySelector('button.create-order-btn').addEventListener('click', async function(){
  
    const pshElement = document.querySelector('.preferred-shipping-method input:checked');
    if(pshElement){
     const psmValue = pshElement.value;
     if(psmValue == 'Other'){
       const psmOtherText = document.querySelector('.preferred-shipping-method .psm-items input')?.value;
       if(psmOtherText == ''){
         document.querySelector('.preferred-shipping-method .psm-items')?.classList.add('error');
         document.querySelector('.closest-lab-wrapper').scrollIntoView({ behavior: 'smooth' });
         return true;
       }
     }
    }else{
      document.querySelector('.preferred-shipping-method').classList.add('error');
      document.querySelector('.closest-lab-wrapper').scrollIntoView({ behavior: 'smooth' });
      return true;
    }

    var paymentMethod = document.querySelector('.stp-payment-box input[name="payment_method"]:checked').value;
    if(pshElement.value == 'Send to my nominated Reseller' && paymentMethod != 'Bill through Reseller'){
      const spbError = document.querySelector('.stp-psm-btr-error');
      if (spbError) {spbError.style.display = 'block';}
      return true;
    }

  
    const accept_tc = document.querySelector('.accept-term-condition input').checked;
    if(!accept_tc){
      document.querySelector('.accept-term-condition').classList.add('error');
      return true;
    }

    
    const srelo = document.querySelector('.selected-reseller-lication').dataset.location;
    if(paymentMethod == 'Bill through Reseller' && !srelo){
      document.querySelector('.reseller-list-popup').classList.add('error');
      document.querySelector('.reseller-list-popup').scrollIntoView({ behavior: 'smooth' });
      return true;
    };

      const accountnumber = document.querySelector('.bill-throght-reseller .btr-account-info input#account-number').value;
    // if(paymentMethod == 'Bill through Reseller' && accountnumber == ''){
    //   document.querySelector('.bill-throght-reseller .btr-account-info').classList.add('error');
    //   document.querySelector('.bill-throght-reseller .btr-account-info').scrollIntoView({ behavior: 'smooth' });
    //   return true;
    // };
  
       const capricornInput = document.querySelector('.pay-with-capricorn .btr-account-info input#account-number');
    // if(paymentMethod == 'Pay with Capricorn' && capricornInput && capricornInput.value == ''){
    //   document.querySelector('.pay-with-capricorn .btr-account-info').classList.add('error');
    //   document.querySelector('.pay-with-capricorn .btr-account-info').scrollIntoView({ behavior: 'smooth' });
    //   return true;
    // };

    
    
    this.classList.add('loading');

  
    // let faults = '';
    // document.querySelectorAll('.faults-checkbox-wrap input:checked').forEach(item => {
    //    if(faults == ''){faults = item.value;}else{faults += ', '+item.value;}
    // });

    // const fault_Description = document.querySelector('.stp-form-main textarea[name="fault-description"]')?.value;
    const fault_codes = document.querySelector('.additional-details-or-codes textarea')?.value;
    

    const vin_rego_input = document.querySelector('.vin-or-rego-wrapper input[type="text"]');
    const vin_rego = vin_rego_input?.value ? vin_rego_input?.value : "I don't have a VIN or Rego";

    // const cbc = document.querySelector('select#customer-business-category').value;
    // const cbn = document.querySelector('input#customer-business-name').value;
    const emailId = customer.email;
    const addAttributeArr = [{"name":"Email","value":emailId },{"name":"Payment Method","value":paymentMethod}];

    const jobcompletion = document.querySelector('.job-completion input').checked;
    if(jobcompletion){addAttributeArr.push({"name":"Request 48 hour","value":'Selected' });}
  
    const authorise = document.querySelector('.authorise-checkbox input').checked;
    if(authorise){addAttributeArr.push({"name":"Authorise","value":'Selected' });}
  
    // if(faults){addAttributeArr.push({"name":"Faults","value":faults});}
    // if(fault_Description){addAttributeArr.push({"name":"Fault Description","value":fault_Description});}
    if(fault_codes){addAttributeArr.push({"name":"fault codes","value":fault_codes});}
    if(vin_rego_input?.value != undefined){addAttributeArr.push({"name":"Vin or Rego","value":vin_rego});}
    if(paymentMethod == 'Bill through Reseller' && srelo){addAttributeArr.push({"name":"Selected Reseller Location","value":srelo})}
    if(paymentMethod == 'Bill through Reseller' && accountnumber != ''){addAttributeArr.push({"name":"Account Number","value":accountnumber})}
    if(paymentMethod == 'Pay with Capricorn' && capricornInput && capricornInput.value != ''){addAttributeArr.push({"name":"Membership Number","value":capricornInput.value})}
  
    // document.querySelectorAll('.normal-partnumber-wrap input').forEach(input => {
    //   const name = input.getAttribute('name'), value = input.value;
    //   addAttributeArr.push({"name":name.replaceAll('-',' '),"value":value});
    // });

     // const abnNumber = document.querySelector('input#customer-abn-number')?.value;
     // const abnName = document.querySelector('input#customer-abn-number')?.getAttribute('name').replaceAll('_',' ');
     // if(abnNumber){addAttributeArr.push({"name":abnName,"value":abnNumber});}
  
    // document.querySelectorAll('.lets-get-started .form-item-input > input').forEach(input => {
    //   const name = input.getAttribute('name'), lgsValue = input.value;
    //   const valuee = name == 'vin' && lgsValue == '' ? 'VIN is not available' : lgsValue;
    //   addAttributeArr.push({"name":name.replaceAll('-',' '),"value":valuee});
    // });

    document.querySelectorAll('.wnmb-items .form-item.half-width textarea').forEach(textarea => {
      const name = textarea.getAttribute('name'), lgsValue = textarea.value;
      addAttributeArr.push({"name":name.replaceAll('-',' '),"value":lgsValue});
    });

    /* selected item sending*/
    let selectedItem = '';

    document.querySelectorAll('.select-item-onclick .stp-block-img.sio-image.active').forEach(item => {
        const title = item.dataset.id;
        console.log('title', title);
        if (selectedItem === '') {selectedItem = title;
        } else {selectedItem += '~' + title;}
    });
    addAttributeArr.push({"name":"Selected Parts","value":selectedItem});


    const additional_parts = document.querySelector('input.additional-part-input')?.value;
    if(additional_parts){addAttributeArr.push({"name":"Additional Parts","value":additional_parts});}  

    // console.log('addAttributeArr ',addAttributeArr);

    // const send_date = {"email":document.querySelector('input#send-email').checked,"phone":document.querySelector('input#send-sms').checked};
    const send_date = {"email":false,"phone":false};

    let closest_lab = '';
    document.querySelectorAll('.closest-lab-wrapper label.form-item input:checked').forEach(item => {
        if(closest_lab == ''){closest_lab = item.value;}else{closest_lab += ', '+item.value;}
    });
    if(closest_lab != ''){addAttributeArr.push({"name":"Closest Lab","value":closest_lab});}
  
    if(pshElement){
      if(pshElement.value == 'Other'){
         const OtherPSMtext = document.querySelector('.preferred-shipping-method .psm-items input')?.value;
        addAttributeArr.push({"name":"Preferred Shipping Method","value":OtherPSMtext});
      }else{
       addAttributeArr.push({"name":"Preferred Shipping Method","value":pshElement.value});
      }
    }

    console.log('addAttributeArr ',addAttributeArr);
  
    if(pshElement.value == 'Send directly to me'){
      const psmavailable = pshElement.dataset.avl;
      const psmVid = pshElement.dataset.vid;
      if(psmavailable){
        console.log('Available');
        let formData = {items: [{ id: psmVid, quantity: 1, properties: { __postage_fee: true } }]};
        const atcReq = await fetch(window.Shopify.routes.root + "cart/add.js", {method: "POST",headers: { "Content-Type": "application/json" },body: JSON.stringify(formData),});
        console.log('atcReq ',atcReq);
        createOrder(addAttributeArr);
      }else{
        console.log('Not available');
        createOrder(addAttributeArr);
      }
    }else{
      createOrder(addAttributeArr);
    }
});

async function createOrder(addAttributeArr){
  console.log('createOrder function');  
  const cartReq = await fetch('/cart.js');
  const cartJson = await cartReq.json();
  const line_items = cartJson.items.map(line => ({"variant_id":line.id, "quantity": line.quantity,'properties':line.properties}));
  const amount = cartJson.items_subtotal_price / 100;
  const main_line_item =line_items.filter(line => line.properties.__common_faults);
  if(main_line_item.length > 0){addAttributeArr.push({"name":"Faults","value":main_line_item[0]?.properties.__common_faults});}
  
  let mcustomer = customer;
  // console.log('customer ',mcustomer);
  // console.log('line_items ',line_items);
  // console.log('amount ',amount);
  console.log('attributes ',addAttributeArr);
 
  const createOrderReq = await fetch(`${APP_URL}/api/order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({"shopUrl": Shopify.shop, "customer": mcustomer,"line_items": line_items,"amount": amount,"attributes":addAttributeArr,'senddate':customer.send_date}),
    });
  const createOrderRes = await createOrderReq.json();
  // console.log('createOrderRes ',createOrderRes);
  // updateSummery(createOrderRes.data);
  // document.querySelector('.steps-main-wrapper').classList.remove('step-second-active');
  // document.querySelector('.steps-main-wrapper').classList.add('step-third-active');
  // window.scrollTo({top: 0,behavior: 'smooth'});
  // window.clearCart();

  const clearCart = await fetch("/cart/clear.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });

  window.location.href = `/pages/order-confirmation?order=${createOrderRes.data.order.name.replace('#','')}`;
  
}

document.querySelectorAll('.select-item-onclick .stp-block-img').forEach(item => {
    item.addEventListener('click', function(){
      this.classList.toggle('active');
     // document.querySelector('.sio-error-message').innerHTML = '';
    });
});

function updateSummery(data){
  const order = data.order;
  // console.log('order ',order);
  const attributes = order.note_attributes;
  
  let faultsDesc = order.note_attributes.filter(attr => attr.name == 'Fault Description')[0]?.value;
  faultsDesc = faultsDesc ? faultsDesc : order.note_attributes.filter(attr => attr.name == 'description of the fault')[0]?.value;
  
  let vinRego = order.note_attributes.filter(attr => attr.name == 'Vin or Rego')[0]?.value;
  vinRego = vinRego ? vinRego : order.note_attributes.filter(attr => attr.name == 'vin')[0]?.value;
  
  document.querySelector('.prd-invoice-top').innerHTML = 'Your Job Number - '+order.name;
  // document.querySelector('.summery-business-name').innerHTML = order.shipping_address.company;
  document.querySelector('.summery-your-name').innerHTML = order.shipping_address.name;
  document.querySelector('.summery-contact-number').innerHTML = order.shipping_address.phone;
  document.querySelector('.summery-email').innerHTML = order.email;
  document.querySelector('.summery-shipping-address').innerHTML = order.shipping_address.address1+', '+order.shipping_address.country;
  // document.querySelector('.summery-fault-desc').innerHTML = faultsDesc;
  if(vinRego){document.querySelector('.summery-vin').innerHTML = vinRego;}

  const descOfUnit = order.note_attributes.filter(attr => attr.name == 'description of unit')[0]?.value;
  if(descOfUnit){document.querySelector('.summery-description-unit').innerHTML = descOfUnit;}
  
  const faultCode = order.note_attributes.filter(attr => attr.name == 'fault codes')[0]?.value;
  if(faultCode){document.querySelector('.summery-fault-codes').innerHTML = faultCode;}

 const partNumber = order.note_attributes.filter(attr => attr.name == 'part number on unit')[0]?.value;
 if(partNumber){document.querySelector('.summery-part-number').innerHTML = partNumber;}
  
 const make = order.note_attributes.filter(attr => attr.name == 'make')[0]?.value;
 if(make){document.querySelector('.summery-make').innerHTML = make;}

 const model = order.note_attributes.filter(attr => attr.name == 'model')[0]?.value;
 if(model){document.querySelector('.summery-model').innerHTML = model;}

 const year = order.note_attributes.filter(attr => attr.name == 'year')[0]?.value;
 if(year){document.querySelector('.summery-year').innerHTML = year;}

 const faults = order.note_attributes.filter(attr => attr.name == 'Faults')[0]?.value;
 if(faults){document.querySelector('.summery-comman-faults').innerHTML = faults;}

  const line_items = order.line_items;
  const mainproducts = line_items.filter(item => item.properties.some(prop => prop.name === "__main_product"));
  if(mainproducts.length > 0){
    document.querySelector('.summery-sending-item').innerHTML = mainproducts[0].title;
  }else{
    document.querySelector('.summery-sending-item').innerHTML = 'Custom repair';
  }
  const trackJobLink = document.querySelector('.stp3-payment--main a.track-job');
  if (trackJobLink) {
      trackJobLink.setAttribute('href', `/account/orders/${order.token}`);
  }
}


/* customer repair js*/
const crbbButton = document.querySelector('.custom-repair-booking-btn button');
if(crbbButton){
crbbButton.addEventListener('click', function(){
  let validationCompleate = true;

  document.querySelectorAll('.lets-get-started .form-item-input input').forEach(input => {
      if(input.value == ''){
       input.classList.add('error');
       validationCompleate = false;
     }
      const lgsName = input.getAttribute('name');
      const vinNotAvailabel = document.querySelectorAll('.lets-get-started .form-item-input .dont-vin input:checked')?.length;
      if(lgsName == 'vin' && vinNotAvailabel > 0){
       input.classList.remove('error');
        validationCompleate = true;
      }
  });

  document.querySelectorAll('.wnmb-items .form-item.half-width textarea').forEach(textarea => {
    if(textarea.value == ''){
     textarea.classList.add('error');
     validationCompleate = false;
   }
  });

  document.querySelectorAll('.customer-shipping-address input').forEach(item => {
     if(item.value == ''){
       item.classList.add('error');
       validationCompleate = false;
     }

      const name = item.getAttribute('name');
      if(name == 'customer_abn_number'){
       item.classList.remove('error');
       validationCompleate = true;
      }
     
     // const anbNumberType = document.querySelector('select#customer-abn-number-type')?.value;
     // if(anbNumberType == 'no'){
     //   const name = item.getAttribute('name');
     //   if(name == 'customer_abn_number'){
     //     item.classList.remove('error');
     //     validationCompleate = true;
     //   }
     // }
  });

  // document.querySelectorAll('.customer-shipping-address select#customer-abn-number-type').forEach(item => {
  //    if(item.value == ''){
  //      item.classList.add('error');
  //      validationCompleate = false;
  //    }
  // });
  
  if(!validationCompleate){
   document.querySelector('.error-message-wrap').innerHTML = 'Please fill all the requid feild above.';
  }else{
    document.querySelector('.custom-repair-booking-btn button').classList.add('loading');
    setTimeout(function(){
      document.querySelector('.custom-repair-booking-btn button').classList.remove('loading');
      document.querySelector('.steps-main-wrapper').classList.remove('step-first-active');
      document.querySelector('.steps-main-wrapper').classList.add('step-second-active');
      window.scrollTo({top: 0,behavior: 'smooth'});
    },1000);
  }
});
}

document.querySelectorAll('.lets-get-started .form-item-input input').forEach(input => {
    input.addEventListener('keyup', function(){errorMessage();});
});
document.querySelectorAll('.wnmb-items .form-item.half-width textarea').forEach(textarea => {
    textarea.addEventListener('keyup', function(){errorMessage();});
});

// Abn number js
document.querySelectorAll('.form-item select#customer-abn-number-type').forEach(item => {
    item.addEventListener('change', function(){
        const abnType = this.value;
        if(abnType == 'yes'){
            document.querySelector('.form-items label.abn-number-wrap').classList.add('show');
        }else{
            document.querySelector('.form-items label.abn-number-wrap').classList.remove('show')
        }
    });
});

// Edit address js
document.querySelector('.open-edit-addressform')?.addEventListener('click', function(e) {
    e.preventDefault();
    this.classList.add('disappear');
    const country_name = customer.default_address.country_name;
    const countryElement = document.querySelector('.sfw-edit-address select[name="address[country]"]');
    
    if (countryElement) {
        countryElement.value = country_name;
        countryElement.dispatchEvent(new Event('change')); // Trigger the change event
    }
  
    document.querySelector('.set_default_wrapper input').checked = true;
    document.querySelector('.sfw-edit-address').classList.add('active');
    window.scrollBy({ top: 150, left: 0, behavior: 'smooth' });
});

document.querySelectorAll('.sfw-edit-address select[name="address[country]"]').forEach(item => {
    item.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        const provinces = selectedOption.dataset.provinces ? JSON.parse(selectedOption.dataset.provinces) : [];
        // console.log('provinces', provinces);
        if(provinces.length == 0){
            document.querySelector('#AddressProvinceContainer').style.display = 'none';
            document.querySelector('#AddressProvinceContainer select').innerHTML = '';
        }else{
            document.querySelector('#AddressProvinceContainer').style.display = 'block';
            let provinceHTML = ''
            provinces.forEach(province => {
              // console.log('province ',province);
              provinceHTML += `<option value="${province[0]}">${province[0]}</option>`
            });
            document.querySelector('#AddressProvinceContainer select').innerHTML = provinceHTML;
        }
    });
});

document.querySelector('.sfw-edit-address button.cancel')?.addEventListener('click', function(){
    document.querySelector('.open-edit-addressform')?.classList.remove('disappear');
    document.querySelector('.sfw-edit-address').classList.remove('active');
    document.querySelector('.shipping-address-wrapper').scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
});


// back to first step js
document.querySelectorAll('.steps-main-wrapper .product-booking-step a').forEach(step => {
   step.addEventListener('click', function(){
        const hasSecondSetp = this.closest('.steps-main-wrapper').classList.contains('step-second-active');
        if(hasSecondSetp){
          document.querySelector('.steps-main-wrapper').classList.remove('step-second-active');
          document.querySelector('.steps-main-wrapper').classList.add('step-first-active');
        }
       
   });
});

document.querySelectorAll('.order-summary-bottom button.back').forEach(btn => {
   btn.addEventListener('click', function(){
       document.querySelector('.steps-main-wrapper').classList.remove('step-second-active');
        document.querySelector('.steps-main-wrapper').classList.add('step-first-active');
   });
});

document.querySelectorAll('.preferred-shipping-method input').forEach(input => {
    input.addEventListener('change', function(){
        document.querySelector('.preferred-shipping-method').classList.remove('error');
        const psMethod = this.value;
        if(psMethod == 'Other'){
          document.querySelector('.form-items.psm-items').innerHTML = '<label class="form-item"><input type="text" name="preferred_shipping_method" value="" onkeyup="psOther();" placeholder="Please specify"></label>'
        }else{
          document.querySelector('.form-items.psm-items').innerHTML = '';
        }
        if(psMethod == 'Send directly to me'){
          document.querySelector('.checkout-price-table').classList.remove('no-postage-fee')
        }else{
          document.querySelector('.checkout-price-table').classList.add('no-postage-fee')
        }
        if(psMethod == 'Send to my nominated Reseller'){
          document.querySelector('.stp-payment-box')?.classList.add('send-to-reseller-shipping');
          document.querySelector('.bill-through-reseller input').click();
        }else{
          document.querySelector('.stp-payment-box')?.classList.remove('send-to-reseller-shipping');
          document.querySelector('.pay-on-completion input').click();
        }
        const spbError = document.querySelector('.stp-psm-btr-error');
        if (spbError) {spbError.style.display = 'none';}
   });
});

function psOther(){
  document.querySelector('.preferred-shipping-method .psm-items')?.classList.remove('error'); 
}

document.querySelector('.order-summary-bottom label.job-completion input')?.addEventListener('change', function(){
  if(this.checked){
    this.closest('.job-completion').classList.add('active');
  }else{
    this.closest('.job-completion').classList.remove('active');
  }
});